import * as React from "react";
import { useCallback } from "react";
import { useFormikContext } from "formik";
import EventProcedureStepLibraryForm from "../EventProcedureStepLibraryForm";
function StepLibraryFormik({ onClose }) {
  const {
    values: { steps },
    setFieldValue,
    setFieldTouched
  } = useFormikContext();
  const handleAddSteps = useCallback(
    (newSteps) => {
      setFieldValue("steps", newSteps);
      setFieldTouched("steps", true);
      onClose();
    },
    [setFieldTouched, setFieldValue, onClose]
  );
  return /* @__PURE__ */ React.createElement(EventProcedureStepLibraryForm, { selectedSteps: steps, onClose, onAdd: handleAddSteps });
}
export default StepLibraryFormik;
